exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-theme-default a:not(.md-button){color:#fff!important}.v-sidebar-menu .vsm--header{font-size:32px;text-align:center;padding:15px;color:#fff!important}.md-theme-default::-webkit-scrollbar{display:none;overflow:scroll}.md-theme-default{-ms-overflow-style:none;scrollbar-width:none;overflow:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03f171a0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/pages/admin/main.vue
// module id = 271
// module chunks = 0